import { EventengineStopStackTracesService_stopStackTraceServiceGetEntity } from '@festina/life-general-types/life/hooks/EventengineStopStackTracesService_stopStackTraceServiceGetEntity'

export const useFetchLifeStackTrace =
  EventengineStopStackTracesService_stopStackTraceServiceGetEntity.useSuspenseQuery
